/* T8 Frame panels: hover / tap / arrows / keys open a frame strip and swap the name + line; moves on by itself until touched */
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var panels = [].slice.call(root.querySelectorAll('[data-t8-fpn-panel]'));
    var num = root.querySelector('[data-t8-fpn-num]'), name = root.querySelector('[data-t8-fpn-name]'), line = root.querySelector('[data-t8-fpn-line]');
    var index = 0, timer = null, swapT = null;
    var hoverable = window.matchMedia('(hover: hover)').matches;
    function show(i, focus) {
      i = (i + panels.length) % panels.length;
      if (i === index && panels[i].classList.contains('is-active')) return;
      index = i;
      panels.forEach(function (p, k) {
        var on = k === i;
        p.classList.toggle('is-active', on); p.setAttribute('aria-selected', String(on)); p.tabIndex = on ? 0 : -1;
      });
      if (focus) panels[i].focus();
      // phones: keep the opened strip in view inside the sideways row
      var row = panels[i].parentNode;
      if (row.scrollWidth > row.clientWidth + 4) setTimeout(function () { var p = panels[i]; row.scrollTo({ left: Math.max(0, p.offsetLeft - row.offsetLeft - 16), behavior: 'smooth' }); }, 350);
      root.classList.add('is-swapping'); clearTimeout(swapT);
      swapT = setTimeout(function () {
        name.textContent = panels[i].dataset.title || '';
        line.textContent = panels[i].dataset.line || '';
        num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        root.classList.remove('is-swapping');
      }, 180);
    }
    function stop() { clearInterval(timer); timer = null; }
    var secs = Number(root.dataset.autoplay) || 0;
    function start() {
      if (!secs || timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(index + 1); }, secs * 1000);
    }
    panels.forEach(function (p, k) {
      p.addEventListener('click', function () { stop(); show(k); });
      if (hoverable) p.addEventListener('mouseenter', function () { stop(); show(k); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); stop(); show(index + (e.key === 'ArrowRight' ? 1 : -1), true); }
      });
    });
    var prev = root.querySelector('[data-t8-fpn-prev]'), next = root.querySelector('[data-t8-fpn-next]');
    if (prev) prev.addEventListener('click', function () { stop(); show(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); show(index + 1); });
    // only run while on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); }); }, { threshold: .3 }).observe(root);
    } else start();
    root.addEventListener('touchstart', stop, { passive: true });
  }
  function all() { document.querySelectorAll('[data-t8-fpn]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
